import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MultipleChildren } from 'types';

const ScrollToTop: FC<MultipleChildren> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};

export default ScrollToTop;
